const DASH = '—';

export function fmtPct(value, { signed = true } = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return DASH;
  const num = Number(value);
  const sign = signed && num > 0 ? '+' : '';
  return `${sign}${num.toFixed(2)}%`;
}

export function fmtCurrency(value, { signed = false, compact = false } = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return DASH;
  const num = Number(value);
  const abs = Math.abs(num).toLocaleString('en-US', {
    minimumFractionDigits: compact ? 0 : 2,
    maximumFractionDigits: compact ? 0 : 2,
  });
  if (signed) return `${num < 0 ? '-' : '+'}$${abs}`;
  return `${num < 0 ? '-' : ''}$${abs}`;
}

export function safeNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatQuoteNumber(value) {
  const parsed = safeNumber(value);
  if (parsed === null) return '—';
  if (Math.abs(parsed) >= 1000) {
    return parsed.toLocaleString('en-US', { maximumFractionDigits: 2 });
  }
  if (Math.abs(parsed) >= 100) return parsed.toFixed(2);
  return parsed.toFixed(3);
}

export function sentimentClass(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '';
  const num = Number(value);
  if (num > 0) return 'vd-positive';
  if (num < 0) return 'vd-negative';
  return '';
}

/** Sparkline green/red — must match the Gain / Total Return column, not curve shape. */
export function sparklinePositive(gainPct) {
  if (gainPct === null || gainPct === undefined || Number.isNaN(Number(gainPct))) {
    return null;
  }
  return Number(gainPct) >= 0;
}

export function monthKeyFromDate(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

export function addMonthsToKey(monthKey, delta) {
  const [y, m] = String(monthKey).split('-').map(Number);
  const d = new Date(y, (m - 1) + delta, 1);
  return monthKeyFromDate(d);
}
